// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StyleGuideRouteImport } from './routes/style-guide'
import { Route as ParsingRulesRouteImport } from './routes/parsing-rules'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedUnauthorizedRouteImport } from './routes/_protected/unauthorized'
import { Route as ProtectedPortfolioRouteImport } from './routes/_protected/portfolio'
import { Route as ProtectedModelingRouteImport } from './routes/_protected/modeling'
import { Route as ProtectedSettingsRouteRouteImport } from './routes/_protected/settings/route'
import { Route as AuthedPostSignInRouteImport } from './routes/_authed/post-sign-in'
import { Route as AuthedOnboardingRouteImport } from './routes/_authed/onboarding'
import { Route as AuthedBlockedRouteImport } from './routes/_authed/blocked'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthRequestAccessRouteImport } from './routes/_auth/request-access'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as ProtectedUploadsIndexRouteImport } from './routes/_protected/uploads/index'
import { Route as ProtectedFieldsIndexRouteImport } from './routes/_protected/fields/index'
import { Route as ProtectedUploadsNewRouteImport } from './routes/_protected/uploads/new'
import { Route as ProtectedUploadsUploadIdRouteImport } from './routes/_protected/uploads/$uploadId'
import { Route as ProtectedSettingsIndexRouteImport } from './routes/_protected/settings/index'
import { Route as ProtectedSettingsTeamRouteImport } from './routes/_protected/settings/team'
import { Route as ProtectedSettingsSecurityRouteImport } from './routes/_protected/settings/security'
import { Route as ProtectedSettingsProfileRouteImport } from './routes/_protected/settings/profile'
import { Route as AuthedOnboardingVerifyEmailRouteImport } from './routes/_authed/onboarding/verify-email'
import { Route as AuthedOnboardingInvitationsRouteImport } from './routes/_authed/onboarding/invitations'
import { Route as AuthedOnboardingCreateOrganizationRouteImport } from './routes/_authed/onboarding/create-organization'

const StyleGuideRoute = StyleGuideRouteImport.update({
            id: '/style-guide',path: '/style-guide',getParentRoute: () => rootRouteImport
          })
const ParsingRulesRoute = ParsingRulesRouteImport.update({
            id: '/parsing-rules',path: '/parsing-rules',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthedRoute = AuthedRouteImport.update({
            id: '/_authed',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProtectedUnauthorizedRoute = ProtectedUnauthorizedRouteImport.update({
            id: '/unauthorized',path: '/unauthorized',getParentRoute: () => ProtectedRoute
          })
const ProtectedPortfolioRoute = ProtectedPortfolioRouteImport.update({
            id: '/portfolio',path: '/portfolio',getParentRoute: () => ProtectedRoute
          })
const ProtectedModelingRoute = ProtectedModelingRouteImport.update({
            id: '/modeling',path: '/modeling',getParentRoute: () => ProtectedRoute
          })
const ProtectedSettingsRouteRoute = ProtectedSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => ProtectedRoute
          })
const AuthedPostSignInRoute = AuthedPostSignInRouteImport.update({
            id: '/post-sign-in',path: '/post-sign-in',getParentRoute: () => AuthedRoute
          })
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthedRoute
          })
const AuthedBlockedRoute = AuthedBlockedRouteImport.update({
            id: '/blocked',path: '/blocked',getParentRoute: () => AuthedRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthRequestAccessRoute = AuthRequestAccessRouteImport.update({
            id: '/request-access',path: '/request-access',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const ProtectedUploadsIndexRoute = ProtectedUploadsIndexRouteImport.update({
            id: '/uploads/',path: '/uploads/',getParentRoute: () => ProtectedRoute
          })
const ProtectedFieldsIndexRoute = ProtectedFieldsIndexRouteImport.update({
            id: '/fields/',path: '/fields/',getParentRoute: () => ProtectedRoute
          })
const ProtectedUploadsNewRoute = ProtectedUploadsNewRouteImport.update({
            id: '/uploads/new',path: '/uploads/new',getParentRoute: () => ProtectedRoute
          })
const ProtectedUploadsUploadIdRoute = ProtectedUploadsUploadIdRouteImport.update({
            id: '/uploads/$uploadId',path: '/uploads/$uploadId',getParentRoute: () => ProtectedRoute
          })
const ProtectedSettingsIndexRoute = ProtectedSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedSettingsRouteRoute
          })
const ProtectedSettingsTeamRoute = ProtectedSettingsTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => ProtectedSettingsRouteRoute
          })
const ProtectedSettingsSecurityRoute = ProtectedSettingsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => ProtectedSettingsRouteRoute
          })
const ProtectedSettingsProfileRoute = ProtectedSettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => ProtectedSettingsRouteRoute
          })
const AuthedOnboardingVerifyEmailRoute = AuthedOnboardingVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => AuthedOnboardingRoute
          })
const AuthedOnboardingInvitationsRoute = AuthedOnboardingInvitationsRouteImport.update({
            id: '/invitations',path: '/invitations',getParentRoute: () => AuthedOnboardingRoute
          })
const AuthedOnboardingCreateOrganizationRoute = AuthedOnboardingCreateOrganizationRouteImport.update({
            id: '/create-organization',path: '/create-organization',getParentRoute: () => AuthedOnboardingRoute
          })





const AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthRequestAccessRoute: AuthRequestAccessRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignInRoute: AuthSignInRoute,AuthSignUpRoute: AuthSignUpRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const AuthedOnboardingRouteChildren = {
  AuthedOnboardingCreateOrganizationRoute: AuthedOnboardingCreateOrganizationRoute,AuthedOnboardingInvitationsRoute: AuthedOnboardingInvitationsRoute,AuthedOnboardingVerifyEmailRoute: AuthedOnboardingVerifyEmailRoute
}

const AuthedOnboardingRouteWithChildren = AuthedOnboardingRoute._addFileChildren(AuthedOnboardingRouteChildren)



const AuthedRouteChildren = {
  AuthedBlockedRoute: AuthedBlockedRoute,AuthedOnboardingRoute: AuthedOnboardingRouteWithChildren,AuthedPostSignInRoute: AuthedPostSignInRoute
}

const AuthedRouteWithChildren = AuthedRoute._addFileChildren(AuthedRouteChildren)




const ProtectedSettingsRouteRouteChildren = {
  ProtectedSettingsProfileRoute: ProtectedSettingsProfileRoute,ProtectedSettingsSecurityRoute: ProtectedSettingsSecurityRoute,ProtectedSettingsTeamRoute: ProtectedSettingsTeamRoute,ProtectedSettingsIndexRoute: ProtectedSettingsIndexRoute
}

const ProtectedSettingsRouteRouteWithChildren = ProtectedSettingsRouteRoute._addFileChildren(ProtectedSettingsRouteRouteChildren)



const ProtectedRouteChildren = {
  ProtectedSettingsRouteRoute: ProtectedSettingsRouteRouteWithChildren,ProtectedModelingRoute: ProtectedModelingRoute,ProtectedPortfolioRoute: ProtectedPortfolioRoute,ProtectedUnauthorizedRoute: ProtectedUnauthorizedRoute,ProtectedUploadsUploadIdRoute: ProtectedUploadsUploadIdRoute,ProtectedUploadsNewRoute: ProtectedUploadsNewRoute,ProtectedFieldsIndexRoute: ProtectedFieldsIndexRoute,ProtectedUploadsIndexRoute: ProtectedUploadsIndexRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRouteWithChildren,AuthedRoute: AuthedRouteWithChildren,ProtectedRoute: ProtectedRouteWithChildren,ParsingRulesRoute: ParsingRulesRoute,StyleGuideRoute: StyleGuideRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)